(function () {
  'use strict';

  /* ---------- announcement bar rotator ----------
     Reads messages from DOM blocks so the theme editor controls them.
  ---------------------------------------------------------------- */
  var annItems = [].slice.call(document.querySelectorAll('.fc-announce-msg'));
  if (annItems.length > 1) {
    var annIdx = 0;
    setInterval(function () {
      var cur = annItems[annIdx];
      cur.style.opacity = '0';
      setTimeout(function () {
        cur.style.display = 'none';
        annIdx = (annIdx + 1) % annItems.length;
        var next = annItems[annIdx];
        next.style.display = '';
        next.offsetHeight; // force reflow before fade-in
        next.style.opacity = '1';
      }, 420);
    }, 5200);
  }

  /* ---------- sticky header shrink ---------- */
  var fcHeader = document.getElementById('fc-header-section');
  if (fcHeader) {
    function onScroll() {
      if (window.scrollY > 24) fcHeader.classList.add('fc-scrolled');
      else fcHeader.classList.remove('fc-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu drawer ---------- */
  var fcScrim   = document.getElementById('fc-scrim');
  var fcDrawer  = document.getElementById('fc-drawer');
  var fcOpenBtn = document.getElementById('fc-open-menu');
  var fcCloseBtn= document.getElementById('fc-close-menu');

  function openDrawer() {
    if (fcDrawer) fcDrawer.classList.add('fc-open');
    if (fcScrim)  fcScrim.classList.add('fc-open');
    document.body.style.overflow = 'hidden';
    if (fcDrawer) fcDrawer.focus();
  }
  function closeAll() {
    if (fcDrawer) fcDrawer.classList.remove('fc-open');
    if (fcScrim)  fcScrim.classList.remove('fc-open');
    document.body.style.overflow = '';
  }

  if (fcOpenBtn)  fcOpenBtn.addEventListener('click', openDrawer);
  if (fcCloseBtn) fcCloseBtn.addEventListener('click', closeAll);
  if (fcScrim)    fcScrim.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.querySelectorAll('.fc-menu-link').forEach(function (a) {
    a.addEventListener('click', closeAll);
  });

  /* ---------- reveal on scroll ---------- */
  var reveals = [].slice.call(document.querySelectorAll('.fc-reveal'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('fc-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
    /* fallback: reveal anything still hidden after 2.6 s */
    setTimeout(function () {
      reveals.forEach(function (el) {
        if (!el.classList.contains('fc-in')) {
          el.style.transition = 'none';
          el.classList.add('fc-in');
        }
      });
    }, 2600);
  } else {
    reveals.forEach(function (el) { el.classList.add('fc-in'); });
  }
})();
